import React, { useState, useContext } from "react";
import './item.css';
import { ShopContext } from "../../context/shopContext";
import unfav from '../assets/heart-white.svg';
import fav from '../assets/heart-solid-white.svg';
import bag from '../assets/cart-shopping-solid.svg';
import Modal from '../cardModal/cardModal';

const Item = (props) => {
    const { isFavourite, addToFavourites, removeFromFavourites, addToCart } = useContext(ShopContext);
    const [contactModal, setContactModal] = useState(false);

    const handleFavoriteClick = () => {
        if (isFavourite(props.id)) {
            removeFromFavourites(props.id);
        } else {
            addToFavourites(props.id);
        }
    };

    const handleAddToCart = () => {
        addToCart({ itemId: props.id });
    };

    return (
        <div>
            <div className="item">
                <img onClick={() => setContactModal(true)} className="product-image" src={props.image} alt="" />
                <p onClick={() => setContactModal(true)} className="product-title">{props.name}</p>

                <div className="item-icons">
                    {isFavourite(props.id) ? (
                        <span onClick={handleFavoriteClick}>
                            <img className="fav-icon" src={fav} alt="Favorited" />
                        </span>
                    ) : (
                        <span onClick={handleFavoriteClick}>
                            <img className="fav-icon" src={unfav} alt="Not Favorited" />
                        </span>
                    )}
                    <img onClick={handleAddToCart} className="item-bag-icon" src={bag} alt="Add to Cart" />
                </div>
            </div>

            {contactModal && (
                <Modal
                    key={props.id}
                    id={props.id}
                    name={props.name}
                    image={props.image}
                    price={props.price}
                    shortDescription={props.shortDescription}
                    longDescription={props.longDescription}
                    occasion={props.occasion}
                    closeContactModal={setContactModal}
                />
            )}
        </div>
    );
};

export default Item;
